/**
 * TanStack Query mutation for patching assignment status.
 * PATCH /api/assignments/:id/status
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';
import { sessionDashboardKeys } from './use-session-dashboard';

export type AssignmentStatus = 'draft' | 'published' | 'closed';

export function useUpdateAssignmentStatus(classId: string, sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: AssignmentStatus }) =>
      api.patch<unknown>(`/api/assignments/${id}/status`, { status }),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionDashboardKeys.bySession(classId, sessionId),
      });
    },
  });
}
